import React from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardBody } from "shards-react";

import colors from "../utils/colors";
import Chart from "../utils/chart";

class Charts extends React.Component {
  constructor(props) {
    super(props);

    this.canvasRef = React.createRef();
    this.chartInstance = null; // Referencia al gráfico de Chart.js
  }

  componentDidMount() {
    this.createChart();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.chartData !== this.props.chartData ||
      prevProps.chartOptions !== this.props.chartOptions
    ) {
      this.updateChart();
    }
  }

  createChart() {
    const chartConfig = {
      type: "doughnut",
      options: {
        ...{
          legend: false,
          cutoutPercentage: 80,
          tooltips: {
            enabled: false,
            mode: "index",
            position: "nearest"
          }
        },
        ...this.props.chartOptions
      },
      data: this.props.chartData
    };

    this.chartInstance = new Chart(this.canvasRef.current, chartConfig);
  }

  updateChart() {
    if (this.chartInstance) {
      this.chartInstance.data = this.props.chartData;
      this.chartInstance.options = {
        ...this.chartInstance.options,
        ...this.props.chartOptions
      };
      this.chartInstance.update();
    }
  }

  componentWillUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }

  render() {
    const { title, withlabels, withTitle } = this.props;
    const labels = this.getParsedLabels();
    return (
      <Card small className="ubd-stats h-auto">
        {withTitle && (
          <CardHeader className="border-bottom">
            <h6 className="m-0">{title}</h6>
            <div className="block-handle" />
          </CardHeader>
        )}

        <CardBody className="d-flex flex-column">
          {/* Chart */}
          <canvas
            width="10"
            ref={this.canvasRef}
            className="analytics-users-by-device"
          />

          {/* Legend */}
          <div className="ubd-stats__legend">
            {labels.slice(0, 5).map((label, idx) => (
              <div key={idx} className="ubd-stats__item">
                {label.icon && (
                  <div
                    dangerouslySetInnerHTML={{ __html: label.icon }}
                    style={{ color: label.iconColor }}
                  />
                )}
                {withlabels ? (
                  <React.Fragment>
                    <span
                      className="ubd-stats__category"
                      style={{ fontSize: 10 }}
                    >
                      {label.title} ({label.value})
                    </span>
                  </React.Fragment>
                ) : null}
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    );
  }

  getParsedLabels() {
    const { chartData } = this.props;

    if (!chartData || typeof chartData.labels === "undefined") {
      return [];
    }

    return chartData.labels.map((label, idx) => {
      const dataset = chartData.datasets[0];
      console.log("dataset!", label);
      return {
        title: label,
        icon: dataset.icons[idx],
        iconColor: dataset.backgroundColor[idx],
        value: dataset.data[idx]
      };
    });
  }
}

Charts.propTypes = {
  title: PropTypes.string,
  chartOptions: PropTypes.object,
  chartData: PropTypes.object,
  withlabels: PropTypes.bool,
  withTitle: PropTypes.bool
};

Charts.defaultProps = {
  title: "Users by Device",
  chartOptions: {},
  withlabels: false,
  withTitle: true,
  chartData: {
    labels: ["SANOFI", "SHIRE", "Otros"],
    datasets: [
      {
        hoverBorderColor: colors.white.toRGBA(1),
        data: [68.3, 24.2, 7.5],
        icons: [
          '<i class="material-icons">&#xE30B;</i>',
          '<i class="material-icons">&#xE32F;</i>',
          '<i class="material-icons">&#xE325;</i>'
        ],
        backgroundColor: [
          colors.primary.toRGBA(0.9),
          colors.primary.toRGBA(0.5),
          colors.primary.toRGBA(0.3)
        ]
      }
    ]
  }
};

export default Charts;
